import { createLoadingScreen } from "../DomUtilities/ElementsCreator";
import openErrorModal from "../Error/ErrorModal";
import { deleteItem, fetchDeleteItemModal } from "../HTTPRequests/ItemRequests";
import Mediator from "../Utilities/Mediator";

export default class DeleteItemModal {
	loadingScreen: HTMLElement;
	itemId: string;
	editModalDiv: HTMLDivElement;

	constructor(itemId: string, editModal: HTMLDivElement) {
		this.loadingScreen = createLoadingScreen();
		this.itemId = itemId;
		this.editModalDiv = editModal;
	}

	public addDeleteModalClickListener() {
		const deleteButton: HTMLButtonElement = document.querySelector('#update-item-modal button');
		deleteButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.fetchModal();
		}
	}

	private fetchModal() {
		fetchDeleteItemModal(this.itemId)
			.then((response: string) => {
				this.openModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	public openModal(modalHTMLString: string) {
		const modalDiv: HTMLDivElement = document.createElement("div");
		modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(modalDiv);

		this.addModalButtonsClickListeners(modalDiv);
	}

	private addModalButtonsClickListeners(modalDiv: HTMLDivElement) {
		const cancelButton: HTMLButtonElement = modalDiv.querySelector('#cancel');
		const image: HTMLImageElement = modalDiv.querySelector('img[alt="close icon"]');
		const saveButton: HTMLButtonElement = modalDiv.querySelector('button:last-child');

		cancelButton.onclick = () => {
			modalDiv.remove();
		};

		image.onclick = () => {
			modalDiv.remove();
		}

		saveButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.deleteItem(modalDiv);
		}
	}

	private deleteItem(modalDiv: HTMLDivElement) {
		const comboItems: NodeListOf<HTMLLIElement> = modalDiv.querySelectorAll("#delete li");
		let comboItemsIds = new Array<string>();
		comboItems.forEach(item => {
			comboItemsIds.push(item.id);
		});

		deleteItem(this.itemId, comboItemsIds)
			.then(() => {
				modalDiv.remove();
				this.editModalDiv.remove();
				Mediator.emit("itemCrudOperationFinished");
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}
}
